import React,{useState} from "react";
import api, { AppTreeDTO,AppUserMemory } from "api";
import { appTree } from "utils";
import { Icon } from "antd";

interface ProjectTreeProps{
    treeData?:  IAppTreeDTO[]
    expandLevel?:number
    value?:IAppTreeDTO
    userMemory?:AppUserMemory
    onChange?: (data: IAppTreeDTO) => void;
}


export interface IAppTreeDTO extends AppTreeDTO{
    _table_hidden?:boolean
    _table_indeterminate?:boolean
    _table_expand_icon?:string
    _tree_code?:string
    _tree_level?:number
    _tree_end?:boolean
    _tree_children?:any[]
}

export const ProjectTreeTable = (props:ProjectTreeProps) =>{

    const [treeData,setTreeData] = useState(initTreeData(props));
    const [value,setValue] = useState( {...props.value});

    const handleRowClick = async (newValue: IAppTreeDTO) => {
        if(!newValue.allowSelect) return;
        
		if (newValue.id !== value.id) {
            props.onChange && props.onChange(newValue);
            let container = refDiv.current.parentElement.parentElement;
            let spanText = container.querySelector('.full-name-span')
            spanText.innerHTML = newValue.fullName;
            let content:any = container.querySelector('.project-tree-content');
            content.style.display = 'none'; 
            let newUserMemory = {...props.userMemory,dataValue:newValue.id,dataName:newValue.name}
            await api.public.component.setValue(newUserMemory);
            setValue(newValue);
		} 
	};

    const handleTreeClick = (eventData: IAppTreeDTO) =>{
        eventData._table_expand_icon === 'caret-right'? handleTreeExpand(eventData):handleTreeShrink(eventData)
    }

    const handleTreeExpand = (eventData:IAppTreeDTO) =>{
        let newTreeData : IAppTreeDTO[] = [];
        treeData.map((data:IAppTreeDTO)=>{
            if(data.id === eventData.id){
                newTreeData.push({...data,_table_expand_icon:'caret-down'})
            }else if(data.parentId === eventData.id){
                newTreeData.push({...data,_table_hidden:false})
            }else{
                newTreeData.push({...data})
            }
        })
        setTreeData(newTreeData)
    }

    const handleTreeShrink = (eventData:any) =>{
        let newTreeData : IAppTreeDTO[] = [];
        let treeCode = eventData._tree_code
        treeData.map((data:any)=>{
            if(data.id === eventData.id){
                newTreeData.push({...data,_table_expand_icon:'caret-right'})
            }else if (data._tree_code.indexOf(treeCode)===0){
                newTreeData.push({...data,_table_expand_icon:'caret-right',_table_hidden:true})
            }else{
                newTreeData.push({...data})
            }

        })
        setTreeData(newTreeData)
    }

    // 展开图标
	const renderIcon = (rowData:IAppTreeDTO) =>{
		if(rowData._tree_end) return <React.Fragment/>
        return <div className='tree-icon' 
                    onClick={() => handleTreeClick(rowData)} 
                    style={{float:'left'}}  >
                    <Icon  type={rowData._table_expand_icon}  />
                </div>
      }
      
    const refDiv = React.createRef<HTMLDivElement>();

    return(<div className="app-tree-container" ref={refDiv}>
        <table style={{ width: "100%" }} cellSpacing="0" cellPadding="0">
            <tbody>
                {treeData.map((rowData:IAppTreeDTO)=>{
                    let {id,_tree_end,_tree_level} = rowData
                    let actived = value.id && value.id===id;
                    let blankWidth:number = _tree_end? _tree_level : (_tree_level-1);
                    blankWidth = blankWidth * 15 +5;
                    return (
                        <tr className='tree-tr' 
                            data-selected={actived} 
                            hidden={rowData._table_hidden} 
                            key={rowData.id} >
                                <td className="tree-td" >
                                    <div className="tree-td-blank" style={{width:blankWidth}}></div>
                                    <div className="tree-data" title={rowData.name} >
                                    {renderIcon(rowData)}
                                    
                                    <div onClick={()=>handleRowClick(rowData)}  style={{flex:1}}>
                                    <span style={{color:'#c3bbbb',padding:"0px 5px 0px 3px"}} className='qcciconfont-organtree-gongsi' hidden={rowData.dataType!=='xm'}></span>
                                    {rowData.name}
                                    </div>
                                    </div>
                                </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    </div>);

}

const initTreeData = (props:ProjectTreeProps) =>{
    let newTreeData : IAppTreeDTO[] = appTree.list(props.treeData)
    return newTreeData.map((data: IAppTreeDTO, index:number) => {
        return {...data,
            _table_hidden:data._tree_level > props.expandLevel,
            _table_indeterminate :false,
            _table_expand_icon:data._tree_level < props.expandLevel ? 'caret-down' : 'caret-right'
        } as IAppTreeDTO
    })
}


// WEBPACK FOOTER //
// ./src/qcc/AppProjectTree/ProjectTreeTable.tsx